type InlineFilenameEditorProps = {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
};

export default function InlineFilenameEditor({
  value,
  onChange,
  onSave,
  onCancel,
}: InlineFilenameEditorProps) {
  return (
    <div className="mb-2">
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSave();
            if (e.key === "Escape") onCancel();
          }}
          className="flex-1 px-2 py-1.5 text-sm border border-indigo-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          autoFocus
        />
        <button
          onClick={onSave}
          className="w-7 h-7 flex items-center justify-center bg-indigo-500 hover:bg-indigo-600 text-white rounded-lg transition-all cursor-pointer flex-shrink-0"
          aria-label="저장"
        >
          <i className="ri-check-line text-sm"></i>
        </button>
        <button
          onClick={onCancel}
          className="w-7 h-7 flex items-center justify-center bg-gray-200 hover:bg-gray-300 text-gray-600 rounded-lg transition-all cursor-pointer flex-shrink-0"
          aria-label="취소"
        >
          <i className="ri-close-line text-sm"></i>
        </button>
      </div>
    </div>
  );
}
